module.exports = __webpack_public_path__ + "media/assets/faria_products/CONNECT-9fa4a390abea625b6a32af676e7a09fef9103d208f5b9d8cbd93ad64eea9b7f5.png";